import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _typeof from "@babel/runtime-corejs3/helpers/typeof";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["className", "style"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context25; _forEachInstanceProperty(_context25 = ownKeys(Object(source), true)).call(_context25, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context26; _forEachInstanceProperty(_context26 = ownKeys(Object(source))).call(_context26, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/reduce";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import { isArray, mergeWith, isPlainObject, isFunction, flatten, merge, get, set, omit, identity } from 'lodash';

var defaultMerge = function defaultMerge() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return _filterInstanceProperty(classes).call(classes, Boolean).join(' ');
};
/**
 * Merges component style overrides by deep merging the actual keys, turning string
 * class names into arrays of string class names in the process. Used to merge style
 * override in nested style providers.
 * @param  {Object} components
 * @param  {Object} parentComponents
 * @return {Object}
 */


export function mergeComponents() {
  var _context, _context2, _context3;

  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var parentComponents = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var base = _reduceInstanceProperty(_context = _filterInstanceProperty(_context2 = _Object$keys(components)).call(_context2, function (key) {
    return !parentComponents[key];
  })).call(_context, function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, components[key]));
  }, {});

  return _reduceInstanceProperty(_context3 = _Object$keys(parentComponents)).call(_context3, function (acc, componentName) {
    var _context4, _context5, _context6;

    var cObj = components[componentName];
    var pcObj = parentComponents[componentName];

    if (!cObj) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, componentName, pcObj));
    }

    var bObj = _reduceInstanceProperty(_context4 = _filterInstanceProperty(_context5 = _Object$keys(cObj)).call(_context5, function (k) {
      return !pcObj[k];
    })).call(_context4, function (acc, key) {
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, cObj[key]));
    }, {});

    var mObj = _reduceInstanceProperty(_context6 = _Object$keys(pcObj)).call(_context6, function (acc, key) {
      var _context7;

      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, _concatInstanceProperty(_context7 = []).call(_context7, _toConsumableArray(isArray(cObj[key]) ? cObj[key] : [cObj[key]]), _toConsumableArray(isArray(pcObj[key]) ? pcObj[key] : [pcObj[key]]))));
    }, bObj);

    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, componentName, mObj));
  }, base);
}
/**
 * Deep merge tokens, with some custom logic to fall back to a token
 * value from the parent if the new value is a function and the function
 * returns undefined
 * @param  {Object} tokens
 * @param  {Object} parentTokens
 * @return {Object}
 */

export function mergeTokens(tokens) {
  var parentTokens = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return mergeWith({}, parentTokens, tokens, function (a, b) {
    if (!isPlainObject(b) && (isFunction(b) || isFunction(a))) {
      return function () {
        var _ref;

        return (_ref = isFunction(b) ? b.apply(void 0, arguments) : b) !== null && _ref !== void 0 ? _ref : isFunction(a) ? a.apply(void 0, arguments) : a;
      };
    }
  });
}
/**
 * Token function generator - returns a function that resolves
 * a token name based on the given tokens
 * @param {Object} tokens
 * @return {Function}
 */

export function createTokenFn(tokens) {
  return function token(value, fallback) {
    var _val;

    // There is no need for recursion here, since we will use the token
    // function nested, so the fallback will already be evaluated!
    // e.g. `token('foo', token('bar', 2))`
    var val = get(tokens, value);

    if (isFunction(val)) {
      // If the value is a function, that function could still return
      // undefined, in which case we still want to use the fallback
      val = val({
        token: token
      });
    }

    return (_val = val) !== null && _val !== void 0 ? _val : fallback;
  };
}
/**
 * Class names are expected to be either a string or a function.
 * If it's a function, we want to execute that function with some parameters
 * (e.g. tokens) and resolve to whatever the function returns (which we expect
 * to be the final class string)
 * @param  {Array} classNames
 * @param  {Object} tokens
 * @return {Array}
 */

export function resolveClassNames(classNames, createTokenFn) {
  var tokens = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var token = createTokenFn(tokens);
  return _mapInstanceProperty(classNames).call(classNames, function (className) {
    if (typeof className === 'function') {
      return className({
        token: token
      });
    }

    return className;
  });
}
/**
 * Creates a `styles` method specifc to given styles, component name,
 * component overrides and tokens, which all comes from the current context
 * and the `styled` decorator arguments
 * @param  {Object} directStyles
 * @param  {String} name
 * @param  {Object} components
 * @param  {Object} tokens
 * @param  {Function} createTokenFunction
 * @return {Function}
 */

export function getStyleUtil() {
  var _context8, _context9, _context10;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      directStyles = _ref2.directStyles,
      propStyles = _ref2.propStyles,
      name = _ref2.name,
      components = _ref2.components,
      tokens = _ref2.tokens,
      _ref2$mergeClasses = _ref2.mergeClasses,
      mergeClasses = _ref2$mergeClasses === void 0 ? defaultMerge : _ref2$mergeClasses,
      _ref2$createTokenFunc = _ref2.createTokenFunction,
      createTokenFunction = _ref2$createTokenFunc === void 0 ? createTokenFn : _ref2$createTokenFunc;

  var matches = _reduceInstanceProperty(_context8 = _mapInstanceProperty(_context9 = _filterInstanceProperty(_context10 = _Object$keys(components || {})).call(_context10, function (componentName) {
    return componentName === name;
  })).call(_context9, function (componentName) {
    return components[componentName];
  })).call(_context8, function (acc, c) {
    return mergeComponents({
      x: acc
    }, {
      x: c
    }).x;
  }, {});

  var overrides = matches || {};
  /**
   * Returns an object that can be spread onto a component/element as props,
   * including className and in development mode some other debugging props
   * @param  {...String|Object} keys
   * @return {Object}
   */

  function styles() {
    var appliedKeys = [];

    for (var _len2 = arguments.length, keys = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      keys[_key2] = arguments[_key2];
    }

    var classNames = _reduceInstanceProperty(keys).call(keys, function (acc, key) {
      if (!key) {
        return acc;
      }

      if (typeof key === 'string') {
        var _context11, _context12, _context13;

        appliedKeys.push(_concatInstanceProperty(_context11 = "".concat(name, ".")).call(_context11, key));
        acc = flatten(_filterInstanceProperty(_context12 = _concatInstanceProperty(_context13 = []).call(_context13, _toConsumableArray(acc), [get(directStyles, key), get(propStyles, key), get(overrides, key)])).call(_context12, Boolean));
      } else {
        var _context14, _context15, _context16;

        acc = flatten(_filterInstanceProperty(_context14 = _concatInstanceProperty(_context15 = []).call(_context15, _toConsumableArray(acc), _toConsumableArray(_reduceInstanceProperty(_context16 = _Object$keys(key)).call(_context16, function (acc, k) {
          if (get(key, k)) {
            var _context17;

            appliedKeys.push(_concatInstanceProperty(_context17 = "".concat(name, ".")).call(_context17, k));

            if (get(directStyles, k)) {
              var _context18;

              acc = _concatInstanceProperty(_context18 = []).call(_context18, _toConsumableArray(acc), [directStyles[k]]);
            }

            if (get(propStyles, k)) {
              var _context19;

              acc = _concatInstanceProperty(_context19 = []).call(_context19, _toConsumableArray(acc), [propStyles[k]]);
            }

            if (get(overrides, k)) {
              var _context20;

              acc = _concatInstanceProperty(_context20 = []).call(_context20, _toConsumableArray(acc), [overrides[k]]);
            }
          }

          return acc;
        }, [])))).call(_context14, Boolean));
      }

      return acc;
    }, []);

    var finalClassNames = resolveClassNames(classNames, createTokenFunction, tokens);
    var className = mergeClasses.apply(void 0, _toConsumableArray(finalClassNames));
    return _objectSpread({
      className: className
    }, process.env.NODE_ENV === 'production' ? {} : {
      'data-es-keys': appliedKeys.join(' ')
    });
  }
  /**
   * Returns a function that itself allows specifying additional classNames
   * or inline styles to be applied on top of given key
   * @param  {...String|Object} keys
   * @return {Function}
   */


  function withStyles() {
    for (var _len3 = arguments.length, keys = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      keys[_key3] = arguments[_key3];
    }

    /**
     * @param  {...Object} inlineStyles
     * @return {Object}
     */
    return function () {
      var _context22;

      for (var _len4 = arguments.length, inlineStyles = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        inlineStyles[_key4] = arguments[_key4];
      }

      var _inlineStyles$reduce = _reduceInstanceProperty(inlineStyles).call(inlineStyles, function (acc, el) {
        var _context21;

        // TODO: this check is for backwards compatitibility, we could/should
        // depecate it for consistency, we can provide a codemod to update
        // usage with string autmatically! :)
        var saveEl = typeof el === 'string' ? {
          className: el
        } : el;

        var _ref3 = saveEl || {},
            className = _ref3.className,
            style = _ref3.style,
            inlineStyle = _objectWithoutProperties(_ref3, _excluded);

        var mergedStyle = merge({}, style, inlineStyle);
        return {
          classNames: className ? _concatInstanceProperty(_context21 = []).call(_context21, _toConsumableArray(acc.classNames), [className]) : acc.classNames,
          style: merge({}, acc.style, mergedStyle)
        };
      }, {
        classNames: [],
        style: {}
      }),
          classNames = _inlineStyles$reduce.classNames,
          style = _inlineStyles$reduce.style;

      var props = styles.apply(void 0, keys);
      return _objectSpread(_objectSpread({}, props), {}, {
        className: mergeClasses.apply(void 0, _concatInstanceProperty(_context22 = [props.className]).call(_context22, _toConsumableArray(classNames))),
        style: _Object$keys(style).length ? style : undefined
      });
    };
  }

  styles.with = withStyles;
  return styles;
}
/**
 * Returns an array containing all keys of the given object that
 * contain a function as value by calling itself recursively on
 * nested objects
 * @param  {Object} obj
 * @param  {String} prefix
 * @return {Array}
 */

export function getKeys(obj) {
  var prevKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  var keys = _Object$keys(obj);

  var _keys$reduce = _reduceInstanceProperty(keys).call(keys, function (acc, key) {
    if (typeof obj[key] === 'function') {
      acc[0].push(_concatInstanceProperty(prevKeys).call(prevKeys, key));
    } else if (typeof obj[key] === 'number' || typeof obj[key] === 'string') {
      acc[1].push(_concatInstanceProperty(prevKeys).call(prevKeys, key));
    } else {
      acc[2].push([key]);
    }

    return acc;
  }, [[], [], []]),
      _keys$reduce2 = _slicedToArray(_keys$reduce, 3),
      dynamicKeys = _keys$reduce2[0],
      staticKeys = _keys$reduce2[1],
      rest = _keys$reduce2[2];

  _forEachInstanceProperty(rest).call(rest, function (key) {
    if (_typeof(obj[key]) === 'object') {
      var nextPrevKeys = _concatInstanceProperty(prevKeys).call(prevKeys, key);

      dynamicKeys = _concatInstanceProperty(dynamicKeys).call(dynamicKeys, getKeys(obj[key], nextPrevKeys).dynamicKeys);
      staticKeys = _concatInstanceProperty(staticKeys).call(staticKeys, getKeys(obj[key], nextPrevKeys).staticKeys);
    }
  });

  return {
    dynamicKeys: dynamicKeys,
    staticKeys: staticKeys
  };
}
/**
 * Split a given styles object, returning an object with the same keys,
 * but the top level values are split if they contain any dynamic styles
 * (= attributes with a function as value). This way we can execute "static"
 * styles at script runtime and "dynamic" styles at component runtime.
 *
 * To remain framework agnostic this method takes a function to create a
 * classname from a styles object as its second argument.
 *
 * @param  {Object} styles
 * @param  {Function} createClass
 * @return {Object}
 */

export function splitStyles(styles) {
  var _context23;

  var createClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : identity;
  return _reduceInstanceProperty(_context23 = _Object$keys(styles)).call(_context23, function (acc, key) {
    // Recursively look for object values that are functions, we consider those dynamic
    // values. All dynamic values are evaluated at component instance runtime, while
    // all other styles can be evaluated at script runtime
    var _getKeys = getKeys(styles[key]),
        dynamicKeys = _getKeys.dynamicKeys;

    acc[key] = dynamicKeys.length ? [// This will be run by the styles util at component instance runtime
    function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      function reduceStyles(styles, parentKeys, dynamicKeys) {
        return _reduceInstanceProperty(dynamicKeys).call(dynamicKeys, function (acc, dynamicKey) {
          var _context24;

          var mergedKey = _concatInstanceProperty(_context24 = []).call(_context24, _toConsumableArray(parentKeys), _toConsumableArray(dynamicKey));

          var style = get(styles, mergedKey);
          var newStyles = typeof style === 'function' ? style.apply(void 0, args) : style; // If we return an object from the dynamic style
          // then we can evaluate it as another style object

          if (isPlainObject(newStyles)) {
            var mergedStyles = merge({}, styles, set({}, mergedKey, newStyles));

            var _getKeys2 = getKeys(newStyles),
                newDynamicKeys = _getKeys2.dynamicKeys,
                newStaticKeys = _getKeys2.staticKeys;

            var dynamicStyles = reduceStyles(mergedStyles, mergedKey, newDynamicKeys); // We have to evaluate these "static" styles
            // here because we only know about them
            // after evaluating our dynamic styles

            var staticStyles = reduceStyles(mergedStyles, mergedKey, newStaticKeys);
            var finalStyles = merge({}, staticStyles, dynamicStyles);
            set(acc, dynamicKey, finalStyles);
          } else {
            set(acc, dynamicKey, newStyles);
          }

          return acc;
        }, {});
      }

      return createClass(reduceStyles(styles, [key], dynamicKeys));
    }, // These are the "static" styles we can evaluate now
    createClass(omit(styles[key], dynamicKeys))] : createClass(styles[key]);
    return acc;
  }, {});
}